import React, { HTMLAttributes } from 'react'
import classNames from 'classnames'

import { InputMask } from '@components/form'

import styles from '../../styles.module.scss'
import { FieldProps } from '@components/form/types'

type Input = FieldProps & {
  className?: string
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
}

interface InputPhoneProps {
  ddd: Input
  phone: Input & { mask: '0000-0000' | '00000-0000' }
  container?: Omit<HTMLAttributes<HTMLDivElement>, 'children'>
  disabled?: boolean
}

export const InputPhone = ({
  ddd: { name: dddName, className: dddClassName, label: dddLabel, ...ddd },
  phone: {
    name: phoneName,
    className: phoneClassName,
    label: phoneLabel,
    ...phone
  },
  container: { className, ...container } = {},
  disabled
}: InputPhoneProps) => {
  return (
    <div className={classNames(styles.container, className)} {...container}>
      <InputMask
        mask="(99)"
        name={dddName}
        className={dddClassName}
        label={dddLabel}
        onlyNumbers={true}
        {...ddd}
        disabled={disabled}
      />
      <InputMask
        name={phoneName}
        className={phoneClassName}
        label={phoneLabel}
        {...phone}
        disabled={disabled}
      />
    </div>
  )
}
